import React, { useState } from 'react';
import AppProvider from './app';
import UiProvider from './ui';
import DataProvider from './data';
import {
  initialAppState,
  initialUiState,
  getCustomData,
} from 'config-app/initial-state';

const Provider = ({ data, restore, children }) => {
  // customStep から初期値を取得、 appState.steps に設定
  const initialSelections = data.customStep.map((item, index) => {
    let initialId = item.default;

    let bottleColor = null;
    if(item.bottleColor) {
      bottleColor = item.bottleColor;
    }

    // restore データが存在すれば、初期値を上書き
    if (restore && restore[index]) {
      // パラメータの値が存在するかチェック
      const validate = item.sort.filter((id) => restore[index] === id);
      initialId = validate[0] || initialId;
    }

    return {
      type: item.type,
      source: item.source,
      id: initialId,
      bottleColor: bottleColor,
    };
  });
  // console.log('initialSelections', initialSelections);

  const [dataState, setDataState] = useState({
    ...data,
  });
  const [appState, setAppState] = useState({
    ...initialAppState,
    steps: initialSelections,
    customData: getCustomData(initialSelections, data),
  });
  const [uiState, setUiState] = useState({
    ...initialUiState,
  });

  return (
    <AppProvider value={[appState, setAppState]}>
      <DataProvider value={[dataState, setDataState]}>
        <UiProvider value={[uiState, setUiState]}>{children}</UiProvider>
      </DataProvider>
    </AppProvider>
  );
};

export default Provider;
